/**
 * @namespace Feedback
 * @aka S3.Feedback
 *
 */
S3.Feedback = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'feedback';
  var DATA_KEY = 'swr3.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_TOGGLE: '[data-share=feedback]'
  };

  var Default = {};

  var DefaultType = {};

  function getMailtoUrl(to, subject, body) {
    var args = [];
    if (typeof subject !== 'undefined') {
      args.push('subject=' + encodeURIComponent(subject));
    }
    if (typeof body !== 'undefined') {
      args.push('body=' + encodeURIComponent(body))
    }

    var url = 'mailto:' + encodeURIComponent(to);
    if (args.length > 0) {
      url += '?' + args.join('&');
    }
    return url;
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Feedback = function () {

    function Feedback(element) {
      S3.Util._classCallCheck(this, Feedback);

      var self = this;

      self.element = element;
    }

    Feedback.prototype.show = function toggle(element) {
      var self = this;
      self.element = element || this.element;

      self._showModal();
    };

    /**
     *
     * @private
     */
    Feedback.prototype._showModal = function _showModal() {
      var self = this;

      var toRedaktion = 'info@swr3.de';
      var toTechnik = 'info@swr3.de';
      var link = S3.Util.getCanonical();
      var headline = ($('h1.headline').text() || document.title);

      var technicalInfo = 'OS: ' + jscd.os + ' ' + jscd.osVersion + "\n" +
        'Browser: ' + jscd.browser + ' ' + jscd.browserMajorVersion + ' (' + jscd.browserVersion + ')' + "\n" +
        'Mobile: ' + jscd.mobile + "\n" +
        'Flash: ' + jscd.flashVersion + "\n" +
        'Cookies: ' + jscd.cookies + "\n" +
        'Local Storage: ' + jscd.localStorage + "\n" +
        'Screen Size: ' + jscd.screen + "\n\n" +
        'Timezone: ' + jscd.timeZone + "\n\n" +
        'User Agent: ' + navigator.userAgent + "\n\n";

      var linkRedaktion = getMailtoUrl(toRedaktion, 'Fehler - ' + headline, 'Fehler - ' + headline + ' - ' + link + "\n\n" + 'Liebe Redaktion, auf folgenden Fehler möchte ich aufmerksam machen:' + "\n\n");
      var linkTechnik = getMailtoUrl(toTechnik, 'Techn. Problem - ' + headline, 'Techn. Problem - ' + headline + ' - ' + link + "\n\n" + 'Meine Systeminformationen: ' + "\n" + technicalInfo + "\n\n");

      var id = 'feedback';
      var modalHeader = S3.Util.modalHeader('Mach SWR3.de besser!');
      var modalBody = S3.Util.modalBody('<p>Der Austausch mit dir liegt uns am Herzen. Wir freuen uns über deine E-Mail, die wir gerne beantworten. Wähle dafür bitte eines der drei Themen.</p>' +
        '<div class="btn-group">' +
        '<a href="' + linkRedaktion + '" class="btn btn-secondary btn-block">Redaktioneller Fehler</a>' +
        '<a href="' + linkTechnik + '" class="btn btn-secondary btn-block">Technisches Problem</a>' +
        '<a href="/kontakt/index.html" target="_blank" class="btn btn-secondary btn-block">Sonstiges Feedback</a>' +
        '</div>');
      var modalFooter = S3.Util.modalFooter('<ul class="small list-inline">' +
        '<li><a href="/datenschutz/index.html" target="_blank">Datenschutz</a></li>' +
        '<li><a href="/impressum/index.html" target="_blank">Impressum</a></li>' +
        '<li><a href="/kontakt/index.html" target="_blank">Kontakt</a></li>' +
        '</ul>');

      self.$modal = $(S3.Util.modalDialog(id, modalHeader, modalBody, modalFooter));
      self.$modal.addClass('modal-extended');

      self._bindEventsModal();

      self.$modal.appendTo('body');
      self.$modal.modal({
        backdrop: 'static',
        focus: false
      });

      S3.isOpen = isOpen = true;

      // PIANO
      var data = {
        type: 'action',
        click: 'show',
        click_chapter1: 'Feedback'
      }
      var usabilityClickEvent = new CustomEvent('piano:usabilityClick', {
        detail: data
      });
      document.dispatchEvent(usabilityClickEvent);

    };

    Feedback.prototype._bindEventsModal = function _bindEventsModal() {
      var self = this;

      /*
       * Modalfenster wird geschlossen
       */
      self.$modal.one('click', '[data-dismiss=modal]', function () {
        // PIANO
        var data = {
          type: 'action',
          click: 'close',
          click_chapter1: 'Feedback'
        }
        var usabilityClickEvent = new CustomEvent('piano:usabilityClick', {
          detail: data
        });
        document.dispatchEvent(usabilityClickEvent);

        S3.isOpen = isOpen = false;
      });

      /*
       * Modalfenster wurde geschlossen
       */
      self.$modal.one('hidden.bs.modal', function () {
        self.$modal.modal('dispose');
        self.$modal.off();
        self.$modal.remove();
        self.$modal = null;
      });

      // Close on navigate
      $(document).one('pjax:beforeReplace', function () {
        if (self.$modal) {
          self.$modal.modal('hide');
        }
      });

    }

    // public
    Feedback.prototype.dispose = function dispose() {
      $(this.element).off(EVENT_KEY);
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // private
    Feedback.prototype._getConfig = function _getConfig(config) {
      config = extend({}, Default, config);

      S3.Util.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // static
    Feedback._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var element = this;
        var data = $(element).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : S3.Util._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Feedback(element);
          $(element).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    return Feedback;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();
    Feedback._jQueryInterface.call($(this), 'show');
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Feedback._jQueryInterface;
  $.fn[NAME].Constructor = Feedback;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Feedback._jQueryInterface;
  };

  return Feedback;

})(window.jQuery);
